import './veriday-common';

(function() {
  document.addEventListener('DOMContentLoaded', function() {

  });
})();
